"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../assets/core.css");
const PIXI = __importStar(require("pixi.js"));
const gsap_1 = require("gsap");
const PixiPlugin_1 = require("gsap/PixiPlugin");
const Game_1 = require("./Game");
const Global_1 = require("./Global");
// Register gsap
gsap_1.gsap.registerPlugin(PixiPlugin_1.PixiPlugin);
PixiPlugin_1.PixiPlugin.registerPIXI(PIXI);
const _poki = (0, Global_1.poki)();
function bootstrap() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const into = (document.getElementById('into'));
            const game = yield (new Game_1.Game).init(into);
            _poki === null || _poki === void 0 ? void 0 : _poki.gameLoadingFinished();
            yield (0, Global_1.hideSplashscreen)();
            yield game.resize();
            console.log('Game Loaded');
            yield game.start();
        }
        catch (e) {
            return console.error(e);
        }
    });
}
if ((0, Global_1.isDevice)()) {
    document.addEventListener('deviceready', bootstrap, false);
}
else if ((0, Global_1.isPoki)()) {
    _poki === null || _poki === void 0 ? void 0 : _poki.init().then(() => {
        return bootstrap();
    }).catch((e) => {
        console.error(e);
        return bootstrap();
    });
    _poki === null || _poki === void 0 ? void 0 : _poki.setDebug(!(process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'prod'));
}
else {
    bootstrap().then();
}
